import { createAction } from 'app-components/flux/core/actionHelpers';

export const getUserInfo = createAction(
  'GET_USER_INFO',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const getUserInfoSuccess = createAction('GET_USER_INFO_SUCCESS');
export const getUserInfoFailure = createAction('GET_USER_INFO_FAILURE');

export const userRegisterMeForBeta = createAction(
  'USER_REGISTER_ME_FOR_BETA',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const userRegisterMeForBetaSuccess = createAction('USER_REGISTER_ME_FOR_BETA_SUCCESS');
export const userRegisterMeForBetaFailure = createAction('USER_REGISTER_ME_FOR_BETA_FAILURE');

export const userUnregisterMeForBeta = createAction(
  'USER_UNREGISTER_ME_FOR_BETA',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const userUnregisterMeForBetaSuccess = createAction('USER_UNREGISTER_ME_FOR_BETA_SUCCESS');
export const userUnregisterMeForBetaFailure = createAction('USER_UNREGISTER_ME_FOR_BETA_FAILURE');

export const setAlwaysMFA = createAction(
  'SET_ALWAYS_MFA',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const setAlwaysMFASuccess = createAction('SET_ALWAYS_MFA_SUCCESS');
export const setAlwaysMFAFailure = createAction('SET_ALWAYS_MFA_FAILURE');
